import type { AxiosError } from 'axios'

import axios from 'axios'
import { toast } from 'vue-sonner'

import { BusinessError } from '@/types/api'
import env from '@/utils/env'

export function useAxios() {
  const axiosInstance = axios.create({
    timeout: env.VITE_SERVER_API_TIMEOUT,
  })

  // 创建一个不带认证的axios实例
  const axiosInstanceNoAuth = axios.create({
    timeout: env.VITE_SERVER_API_TIMEOUT,
  })

  axiosInstance.interceptors.request.use((config) => {
    // 从localStorage或sessionStorage中获取token
    const token = sessionStorage.getItem('token')

    // 如果token存在，设置Authorization header
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    return config
  }, (error) => {
    return Promise.reject(error)
  })

  // 不带认证的实例不需要添加token
  axiosInstanceNoAuth.interceptors.request.use((config) => {
    return config
  }, (error) => {
    return Promise.reject(error)
  })

  axiosInstance.interceptors.response.use((response) => {
    // 检查是否是业务层面的错误
    const responseData = response.data
    if (responseData && typeof responseData.code === 'number' && responseData.code < 0) {
      // 显示错误提示
      toast.error(responseData.message || 'Request failed')

      // 抛出业务错误
      const error = new BusinessError(
        responseData.message || 'Business error',
        responseData.code,
        responseData.data,
      )
      return Promise.reject(error)
    }

    return response
  }, (error: AxiosError) => {
    // if status is not 2xx, throw error
    // you can handle error here
    return Promise.reject(error)
  })

  axiosInstanceNoAuth.interceptors.response.use((response) => {
    // 检查是否是业务层面的错误
    const responseData = response.data
    if (responseData && typeof responseData.code === 'number' && responseData.code < 0) {
      // 显示错误提示
      toast.error(responseData.message || 'Request failed')

      // 抛出业务错误
      const error = new BusinessError(
        responseData.message || 'Business error',
        responseData.code,
        responseData.data,
      )
      return Promise.reject(error)
    }

    return response
  }, (error: AxiosError) => {
    // if status is not 2xx, throw error
    // you can handle error here
    return Promise.reject(error)
  })

  return {
    axiosInstance,
    axiosInstanceNoAuth,
  }
}
